<div
  class="flex w-full cursor-pointer flex-col items-start justify-between rounded-2xl outline-solid"
  [style.outline-color]="mainColor()"
  style="outline-offset: 3px; outline-width: 3px"
  (click)="toggleText()">
  <div
    class="flex w-full items-center justify-between p-2"
    [ngClass]="{ 'rounded-2xl': !showText, 'rounded-t-2xl': showText }"
    [style.background-color]="mainColor()"
    [style.color]="mainColor()">
    <div class="flex items-center gap-2">
      <span
        [style.color]="textColorTop()"
        class="material-symbols-rounded text-2xl">
        accessibility_new
      </span>
      <span
        [style.color]="textColorTop()"
        class="text-standard-text-primary text-2xl"
        style="color: white">
        Barrierefreiheit
      </span>
    </div>
    <span
      [style.color]="textColorTop()"
      class="material-symbols-rounded text-base"
      style="color: white">
      {{ showText ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
    </span>
  </div>
  @if (showText) {
    <div [style.color]="textColorBottom()" class="w-full rounded-b-2xl p-4">
      <ng-content />
    </div>
  }
</div>
